export enum FluxRpsiSortOptions {
  'DATE_APPEL' = 'DATE_APPEL',
}
